import route from '../../../src/common/utils/route'
import { FooterItems } from '../../../src/common/constants/footer'

const footer: FooterItems = {
  footer: [
    {
      id: 1,
      name: 'footer.about',
      component: 'standard',
      subtitles: [
        {
          id: 1,
          name: 'footer.company',
          url: route('empresa'),
        },
        {
          id: 2,
          name: 'footer.philosophy',
          url: route('recursos-humanos'),
        },
        {
          id: 3,
          name: 'footer.work_with_us',
          url: 'https://trabajo.rodi.es/',
          external: true,
        },
        {
          id: 4,
          name: 'footer.sponsor',
          url: route('patrocinios.index'),
        },
      ],
    },
    {
      id: 2,
      name: 'footer.legal',
      component: 'standard',
      subtitles: [
        {
          id: 1,
          name: 'footer.legal_warn',
          url: route('aviso-legal'),
        },
        {
          id: 2,
          name: 'footer.terms',
          url: route('condiciones'),
        },
        {
          id: 3,
          name: 'footer.policy',
          url: route('politica-privacidad'),
        },
        {
          id: 4,
          name: 'footer.cookies',
          url: route('cookies'),
        },
        {
          id: 5,
          name: 'footer.canal_etico',
          url: route('canal-etico'),
        },
      ],
    },
    {
      id: 3,
      name: 'footer.neumaticos',
      component: 'standard',
      subtitles: [
        {
          id: 1,
          name: 'footer.michelin',
          url: route('neumaticos.marca', { marca: 'michelin' }),
        },
        {
          id: 2,
          name: 'footer.pirelli',
          url: route('neumaticos.marca', { marca: 'pirelli' }),
        },
        {
          id: 3,
          name: 'footer.goodyear',
          url: route('neumaticos.marca', { marca: 'goodyear' }),
        },
        {
          id: 4,
          name: 'footer.dunlop',
          url: route('neumaticos.marca', { marca: 'dunlop' }),
        },
        {
          id: 5,
          name: 'footer.continental',
          url: route('neumaticos.marca', { marca: 'continental' }),
        },
        {
          id: 6,
          name: 'footer.falken',
          url: route('neumaticos.marca', { marca: 'falken' }),
        },
      ],
    },
    {
      id: 4,
      name: 'footer.atencion_cliente',
      component: 'standard',
      subtitles: [
        {
          id: 1,
          name: 'footer.faq',
          url: route('faq.index'),
        },
        {
          id: 2,
          name: 'footer.contact',
          url: route('contacto.index'),
        },
        {
          id: 3,
          name: 'footer.pro_access',
          url: 'https://www.rodi.es/acceso-profesionales/',
          external: true,
        },
      ],
    },
    {
      id: 5,
      name: 'footer.follow',
      component: 'standard',
      subtitles: [
        {
          id: 1,
          name: 'footer.blog',
          url: route('blog'),
          external: true,
          icon: 'blog',
        },
        {
          id: 2,
          name: 'footer.facebook',
          url: 'https://www.facebook.com/rodimotorservices',
          external: true,
          icon: 'facebook',
        },
        {
          id: 3,
          name: 'footer.instagram',
          url: 'https://www.instagram.com/rodimotorservices/',
          external: true,
          icon: 'instagram',
        },
        {
          id: 4,
          name: 'footer.twitter',
          url: 'https://twitter.com/MotorRodi',
          external: true,
          icon: 'twitter',
        },
        {
          id: 5,
          name: 'footer.linkedin',
          url: 'https://es.linkedin.com/company/rodi-motor-services',
          external: true,
          icon: 'linkedin',
        },
        {
          id: 6,
          name: 'footer.youtube',
          url: 'https://www.youtube.com/user/rodimotorservices',
          external: true,
          icon: 'youtube',
        },
      ],
    },
    {
      id: 6,
      name: 'footer.newsletter',
      component: 'newsletter',
      subtitles: [],
    },
  ],
}

export default footer
